module.exports = __webpack_public_path__ + "img/b-calendar.afe67add.svg";